// Alegria mobile menu (Figma Nav 1b-4 Mobile): full-screen overlay with the
// four top-level nav items as tabs; tapping a tab swaps the panel below.
// Markup contract:
//   <alegria-mobile-menu>
//     <button data-mobile-menu-open>…</button>
//     <dialog data-mobile-menu-dialog>
//       <button data-mobile-menu-close>…</button>
//       <button data-mobile-menu-tab="panel-id">…</button> (×N)
//       <div data-mobile-menu-panel id="panel-id">…</div>  (×N)
//     </dialog>
//   </alegria-mobile-menu>
class AlegriaMobileMenu extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-mobile-menu-dialog]');
    if (!this.dialog) return;

    this.querySelector('[data-mobile-menu-open]')?.addEventListener('click', () => {
      this.dialog.showModal();
      document.documentElement.classList.add('mobile-menu-open');
    });

    this.querySelector('[data-mobile-menu-close]')?.addEventListener('click', () => this.dialog.close());

    this.dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('mobile-menu-open');
    });

    this.tabs = Array.from(this.querySelectorAll('[data-mobile-menu-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-mobile-menu-panel]'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.mobileMenuTab));
    });
  }

  activate(panelId) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.mobileMenuTab === panelId;
      tab.classList.toggle('mobile-menu__tab--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  }
}

if (!customElements.get('alegria-mobile-menu')) {
  customElements.define('alegria-mobile-menu', AlegriaMobileMenu);
}
